import { Send, Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { MicButton } from "@/components/MicButton";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SmsCompose = ({ open, onOpenChange, phone = "", leadId = null, onSent }) => {
  const [form, setForm] = useState({ phone, text: "" });
  const [ask, setAsk] = useState("");
  const [busy, setBusy] = useState("");
  useEffect(() => { if (open) { setForm({ phone, text: "" }); setAsk(""); } }, [open, phone]);

  const draft = async () => {
    setBusy("ai");
    try { const { data } = await api.post("/sms/ai-draft", { instruction: ask, current: form.text }); setForm((f) => ({ ...f, text: data.text })); } catch (e) { toast.error(e?.response?.data?.detail || "Rédaction impossible."); } finally { setBusy(""); }
  };
  const send = async () => {
    setBusy("send");
    try {
      const { data } = await api.post("/sms/send", { phone: form.phone, text: form.text, lead_id: leadId ? String(leadId) : null });
      toast.success(`SMS envoyé au ${data.phone}.`);
      onSent?.(data);
      onOpenChange(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "SMS non envoyé."); } finally { setBusy(""); }
  };
  const count = form.text.length;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sms-compose" data-testid="sms-compose-dialog">
        <DialogHeader>
          <DialogTitle>Nouveau SMS</DialogTitle>
          <DialogDescription>Envoyé via SMS Partner, avec la mention STOP. Il apparaît ensuite dans la conversation.</DialogDescription>
        </DialogHeader>
        <label className="sms-field"><span>Numéro</span><input value={form.phone} placeholder="06 12 34 56 78" onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="sms-compose-phone" /></label>
        <div className="sms-ai">
          <span className="sms-ai-title"><Sparkles size={14} /> Rédiger avec l'IA</span>
          <div className="sms-ai-row">
            <input value={ask} placeholder="Ex. : rappeler le rendez-vous de jeudi 10 h pour la visite technique" onChange={(e) => setAsk(e.target.value)} data-testid="sms-compose-ai-instruction" />
            <MicButton onText={(t) => setAsk((a) => `${a} ${t}`.trim())} testid="sms-compose-ai-mic" label="Dicter" />
            <button type="button" className="secondary-button" disabled={ask.trim().length < 3 || busy === "ai"} onClick={draft} data-testid="sms-compose-ai-generate">{busy === "ai" ? "Rédaction…" : "Rédiger"}</button>
          </div>
        </div>
        <label className="sms-field">
          <span>Message <small className={count > 160 ? "warn" : ""}>{count} caractère{count > 1 ? "s" : ""}{count > 160 ? ` · ${Math.ceil(count / 153)} SMS` : ""}</small></span>
          <textarea rows={5} value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} placeholder="Votre message…" data-testid="sms-compose-text" />
        </label>
        <div className="sms-compose-foot">
          <MicButton onText={(t) => setForm((f) => ({ ...f, text: `${f.text} ${t}`.trim() }))} testid="sms-compose-text-mic" label="Dicter le message" />
          <button type="button" className="primary-button" disabled={!form.phone.trim() || !form.text.trim() || busy === "send"} onClick={send} data-testid="sms-compose-send"><Send size={14} /> {busy === "send" ? "Envoi…" : "Envoyer le SMS"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
